import React, { useState } from 'react';
import tw from 'twin.macro';
import { graphql, StaticQuery } from 'gatsby';
import { css } from '@emotion/react';
import Img, { FluidObject } from 'gatsby-image';
import { ReactComponent as IconCheck } from '../assets/Icon-check.svg';
import { ReactComponent as IconInfo } from '../assets/Icon-info.svg';
import { ReactComponent as MapJakarta } from '../assets/Map-Jakarta.svg';
import MapBandung from '../assets/Map-Bandung.png';
import { ReactComponent as IconLocationWhite } from '../assets/Icon-location-white.svg';
import { GetVirtualOfficeDataQuery } from '../graphql-types';
import { CSSTransition } from 'react-transition-group';

const Tooltip: React.FC<{ style?: React.CSSProperties; className?: string }> = ({
  children,
  style,
  className,
}) => (
  <div
    style={style}
    className={className}
    tw="bg-black-100 border border-white border-solid p-4 rounded-2xl absolute w-1/2 z-10 bottom-8 mb-4"
    css={css`
      &:after {
        position: absolute;
        content: '';
        border: solid #fff;
        width: 17px;
        height: 17px;
        border-width: 0px 0px 1px 1px;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        bottom: -9px;
        left: 45%;
        ${tw`bg-black-100`}
      }
    `}
  >
    {children}
  </div>
);

interface VirtualOfficeCompProps {
  data?: GetVirtualOfficeDataQuery;
  description?: any;
  location?: string;
  background?: string;
  dark?: boolean;
}

export interface Office {
  description?: any;
  location?: string;
}

const VirtualOfficeComp: React.FC<VirtualOfficeCompProps> = ({
  data,
  description,
  location,
  background,
  dark,
}) => {
  const [hoveringContent, setHoveringContent] = useState(0);

  const [currentIndex, setCurrentIndex] = useState(0);

  const [showModal, setShowModal] = useState(false);

  function left() {
    const idx = currentIndex || 0;
    if (idx < 1) {
      return;
    }
    setCurrentIndex(idx - 1);
  }

  function right() {
    const idx = currentIndex || 0;
    if (idx > 6) {
      return;
    }
    setCurrentIndex(idx + 1);
  }

  const resepsionis = data?.resepsionis?.childrenImageSharp[0]?.fluid;
  const meeting1 = data?.meeting1?.childrenImageSharp[0]?.fluid;
  const meeting2 = data?.meeting2?.childrenImageSharp[0]?.fluid;
  // const jakarta = data?.jakarta?.childrenImageSharp[0]?.fluid;
  // const newjakarta = data?.newjakarta?.childrenImageSharp[0]?.fluid;

  const coworking = data?.coworking?.childrenImageSharp[0]?.fluid;
  const ruangmeeting = data?.ruangmeeting?.childrenImageSharp[0]?.fluid;
  const amphitheatre = data?.amphitheatre?.childrenImageSharp[0]?.fluid;

  const contentsJakarta = [
    {
      title: 'Alamat surat menyurat',
      detail: null,
    },
    {
      title: 'Nomor telepon bersama',
      detail: null,
    },
    {
      title: 'Ruang meeting',
      detail: (
        <div>
          Ruang meeting selama 2 jam per bulan. <br /> Untuk reservasi bisa menghubungi admin
          Easybiz.
        </div>
      ),
    },
  ];

  const contentsBandung = [
    {
      title: 'Ruang Meeting 2 jam / bulan',
      detail: null,
    },
    {
      title: '5 Tiket Coworking Space',
      detail: null,
    },
    {
      title: 'Free 1 bulan VO',
      detail: null,
    },
  ];

  const galleryJakarta = [
    {
      title: 'Resepsionis',
      image: resepsionis,
    },
    {
      title: 'Ruang Meeting 1',
      image: meeting1,
    },
    {
      title: 'Ruang Meeting 2',
      image: meeting2,
    },
  ];

  const galleryBandung = [
    {
      title: 'Coworking Area',
      image: coworking,
    },
    {
      title: 'Ruang Meeting',
      image: ruangmeeting,
    },
    {
      title: 'Amphitheatre',
      image: amphitheatre,
    },
  ];

  const gallery = location === 'Bandung' ? galleryBandung : galleryJakarta;
  const contents = location === 'Bandung' ? contentsBandung : contentsJakarta;

  const totalData = gallery.length;

  return (
    <section tw="bg-blue-marine">
      <div
        css={css`
          ${background === 'black'
            ? tw`bg-blue-marine dark:bg-black-100`
            : tw`bg-blue-marine dark:bg-blue-black`}
          ${dark
            ? ''
            : 'background: linear-gradient(270deg,rgba(45, 64, 92, 0.4) 0%,rgba(0, 0, 0, 0.4) 100%);'}
        `}
      >
        <div tw="container">
          <div tw="mx-8 lg:mx-32 py-4 pb-12">
            <h2 tw="text-h2 text-white text-left py-6 m-0">
              Fasilitas <b tw="text-yellow-bright dark:text-orange">Virtual Office</b>
            </h2>
            <div
              tw="justify-start lg:flex"
              css={css`
                @media (max-width: 1024px) {
                  a {
                    ${tw`mb-3`}
                    ${tw`flex`}
                  ${tw`justify-center`}
                  }
                }
              `}
            >
              <div tw="lg:mr-12 my-3 flex flex-col justify-between">
                <div tw="text-h4 text-white">{description}</div>
                <div tw="text-left col-span-2 mt-4">
                  <div tw="text-white">
                    <ul tw="list-none m-0 mb-8">
                      {contents.map((item, i) => (
                        <li
                          key={'contents' + i}
                          tw="text-b1 flex items-center relative"
                          onMouseOver={() => {
                            setHoveringContent(i);
                          }}
                          onMouseLeave={() => {
                            setHoveringContent(null);
                          }}
                        >
                          <IconCheck tw="mr-3 flex-none"></IconCheck>
                          <div
                            tw="flex items-center justify-center"
                            css={css`
                              ${item.detail ? tw`underline` : tw``}
                            `}
                          >
                            <span>{item.title}</span>
                            {item.detail ? <IconInfo tw="ml-2 flex-none"></IconInfo> : <div></div>}
                            {item.detail ? (
                              <Tooltip
                                css={css`
                                  ${hoveringContent === i ? tw`block` : tw`hidden`}
                                `}
                              >
                                {item.detail}
                              </Tooltip>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div tw="flex justify-start lg:justify-start overflow-x-auto lg:overflow-visible pb-8 lg:pb-0">
                  {gallery.map((item, i) => (
                    <div
                      key={'gallery' + i}
                      tw="relative cursor-pointer mr-6"
                      onClick={() => {
                        setCurrentIndex(i);
                        setShowModal(true);
                      }}
                    >
                      <Img
                        alt={item.title}
                        tw="rounded-2xl"
                        fluid={item.image as FluidObject}
                        css={css`
                          height: 215px;
                          width: 161px;
                        `}
                      />
                      <div
                        tw="absolute w-full px-4"
                        css={css`
                          bottom: -0.75rem;
                        `}
                      >
                        <div tw="text-b3 bg-black-300 px-3 py-1 text-white text-center rounded-2xl">
                          {item.title}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div tw="flex flex-col justify-items-start items-center">
                {/* <Img
                  tw="mb-4 mx-2"
                  fluid={newjakarta as FluidObject}
                  css={css`
                    height: 310px;
                    width: 500px;
                    @media (max-width: 1024px) {
                      height: 155px;
                      width: 250px;
                    }
                  `}
                /> */}
                {location === 'Bandung' ? (
                  <img src={MapBandung}
                    css={css`
                      height: 342px;
                      width: 550px;
                      max-width: auto;
                      @media (max-width: 1024px) {
                        height: 171px;
                        width: 225px;
                        ${tw`mb-2`}
                      }
                    `}
                  ></img>
                ) : (
                  <MapJakarta
                    css={css`
                      height: 310px;
                      width: 500px;
                      @media (max-width: 1024px) {
                        height: 155px;
                        width: 250px;
                      }
                    `}
                  ></MapJakarta>
                )}
                <div tw="text-b3 text-white py-1 px-2 text-left flex items-center" css={css``}>
                  <IconLocationWhite tw="mr-2 flex-none dark:text-white"></IconLocationWhite>
                  {location === 'Bandung'
                    ? 'Greko Creative Hub Jl. Jendral Ahmad Yani No.134-136, Malabar, Kec. Lengkong, Kota Bandung, Jawa Barat 40262'
                    : 'PT Justika Solusi Indonesia, AD Premier Office Park Lantai 9 Jl. TB Simatupang No.5 Ragunan, Pasar Minggu, Jakarta Selatan'}
                </div>
              </div>
            </div>
            <div
              tw="fixed w-full h-full top-0 right-0 left-0 bottom-0"
              css={css`
                ${showModal ? tw`block` : tw`hidden`}
                z-index: 10;
                background: rgb(0, 0, 0, 0.4);
              `}
            >
              <div
                tw="absolute w-full h-full cursor-pointer"
                onClick={() => {
                  setShowModal(false);
                }}
              ></div>
              <CSSTransition in={showModal} timeout={300} classNames="modal" unmountOnExit>
                <div
                  tw="relative left-0 lg:left-1/4 top-1/4 w-full lg:w-1/2"
                  css={css`
                    min-height: 50%;
                    @media (min-width: 1025px) {
                      top: 12.5%;
                    }
                  `}
                  onClick={e => e.preventDefault()}
                >
                  <div tw="relative w-full h-full">
                    <div
                      tw="absolute left-0 lg:left-0 h-full top-0 flex flex-col justify-center"
                      css={css`
                        z-index: 11;
                      `}
                    >
                      <button
                        tw="cursor-pointer bg-yellow-bright border-0 p-1 lg:p-2 focus:outline-none"
                        onClick={() => left()}
                        css={css`
                          ${!currentIndex || currentIndex < 1 ? tw`opacity-20` : ``}
                        `}
                        disabled={!currentIndex || currentIndex < 1}
                      >
                        <span
                          tw="text-blue-black text-h4 lg:text-h2"
                          className="icon icon-chevron-left"
                          aria-label="slide-left"
                        ></span>
                      </button>
                    </div>
                    <div
                      tw="absolute right-0 lg:right-0 h-full top-0 flex flex-col justify-center"
                      css={css`
                        z-index: 11;
                      `}
                    >
                      <button
                        tw="cursor-pointer bg-yellow-bright border-0 p-1 lg:p-2 focus:outline-none"
                        onClick={() => right()}
                        css={css`
                          ${currentIndex > totalData - 2 ? tw`opacity-20` : ``}
                        `}
                        disabled={currentIndex > totalData - 2}
                      >
                        <span
                          tw="text-blue-black text-h4 lg:text-h2"
                          className="icon icon-chevron-right"
                          aria-label="slide-right"
                        ></span>
                      </button>
                    </div>
                    <Img
                      alt={gallery[currentIndex].title}
                      fluid={gallery[currentIndex].image as FluidObject}
                      css={css`
                        width: auto;
                        height: 100%;
                      `}
                    />
                  </div>
                </div>
              </CSSTransition>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const virtualOfficeQuery = graphql`
  query getVirtualOfficeData {
    resepsionis: file(relativePath: { eq: "images/virtual-office/resepsionis.png" }) {
      childrenImageSharp {
        fluid(maxHeight: 853) {
          ...FileImageSharpFluid
        }
      }
    }
    meeting1: file(relativePath: { eq: "images/virtual-office/meeting1.png" }) {
      childrenImageSharp {
        fluid(maxHeight: 853) {
          ...FileImageSharpFluid
        }
      }
    }
    meeting2: file(relativePath: { eq: "images/virtual-office/meeting2.png" }) {
      childrenImageSharp {
        fluid(maxHeight: 853) {
          ...FileImageSharpFluid
        }
      }
    }
    ruangmeeting: file(relativePath: { eq: "images/virtual-office/ruangmeeting.png" }) {
      childrenImageSharp {
        fluid(maxHeight: 853) {
          ...FileImageSharpFluid
        }
      }
    }
    coworking: file(relativePath: { eq: "images/virtual-office/coworking.png" }) {
      childrenImageSharp {
        fluid(maxHeight: 853) {
          ...FileImageSharpFluid
        }
      }
    }
    amphitheatre: file(relativePath: { eq: "images/virtual-office/amphitheatre.png" }) {
      childrenImageSharp {
        fluid(maxHeight: 853) {
          ...FileImageSharpFluid
        }
      }
    }
    jakarta: file(relativePath: { eq: "images/virtual-office/jakarta.png" }) {
      childrenImageSharp {
        fluid(maxHeight: 428) {
          ...FileImageSharpFluid
        }
      }
    }
    newjakarta: file(relativePath: { eq: "images/virtual-office/new-jakarta.png" }) {
      childrenImageSharp {
        fluid(maxWidth: 1800) {
          ...FileImageSharpFluid
        }
      }
    }
  }
`;

interface VirtualOfficeProps {
  description?: any;
  location?: string;
  background?: string;
  dark?: boolean;
}

const VirtualOffice: React.FC<VirtualOfficeProps> = ({
  description,
  location,
  background,
  dark,
}) => {
  return (
    <StaticQuery
      query={virtualOfficeQuery}
      render={data => (
        <VirtualOfficeComp
          data={data}
          description={description}
          location={location}
          background={background}
          dark={dark}
        />
      )}
    />
  );
};

export default VirtualOffice;
